export default __webpack_public_path__ + "static/media/bahriddin.d9d62c8b.png";